var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_70_1028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79 15.8333C10.5206 15.8333 12.2123 16.3464 13.6512 17.3079C15.0902 18.2694 16.2117 19.6359 16.8739 21.2348C17.5362 22.8336 17.7095 24.593 17.3719 26.2903C17.0343 27.9876 16.2009 29.5467 14.9772 30.7704C13.7535 31.9941 12.1944 32.8275 10.497 33.1651C8.79971 33.5027 7.04037 33.3295 5.44152 32.6672C3.84267 32.0049 2.4761 30.8834 1.51464 29.4445C0.553179 28.0056 0.04 26.3138 0.04 24.5833L0 23.3333C0 18.692 1.84374 14.2408 5.12563 10.9589C8.40752 7.677 12.8587 5.83325 17.5 5.83325V10.8333C15.8578 10.8288 14.2309 11.15 12.7136 11.7782C11.1962 12.4065 9.81849 13.3293 8.66 14.4933C8.20974 14.9427 7.79437 15.4257 7.4175 15.9383C7.865 15.8683 8.3225 15.8308 8.7875 15.8308L8.79 15.8333ZM31.29 15.8333C33.0206 15.8333 34.7123 16.3464 36.1512 17.3079C37.5902 18.2694 38.7117 19.6359 39.374 21.2348C40.0362 22.8336 40.2095 24.593 39.8719 26.2903C39.5343 27.9876 38.7009 29.5467 37.4772 30.7704C36.2535 31.9941 34.6944 32.8275 32.997 33.1651C31.2997 33.5027 29.5404 33.3295 27.9415 32.6672C26.3427 32.0049 24.9761 30.8834 24.0146 29.4445C23.0532 28.0056 22.54 26.3138 22.54 24.5833L22.5 23.3333C22.5 18.692 24.3437 14.2408 27.6256 10.9589C30.9075 7.677 35.3587 5.83325 40 5.83325V10.8333C38.3578 10.8288 36.7309 11.15 35.2136 11.7782C33.6962 12.4065 32.3185 13.3293 31.16 14.4933C30.7097 14.9427 30.2944 15.4257 29.9175 15.9383C30.365 15.8683 30.8225 15.8308 31.29 15.8308V15.8333Z",
    fill: "black",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_1028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.4d9b2c8e9b0889895dd89d41bdbe61be.svg";
export { ForwardRef as ReactComponent };